import { useSelector, useDispatch } from 'react-redux';
import { getSearchOptions } from '../selectors';
import * as searchActions from '../actions';

export const AiToggle = ({ disabled }: { disabled?: boolean }) => {
  const dispatch = useDispatch();
  const searchOptions = useSelector(getSearchOptions);

  return (
    <span
      title="AI powered search option with image recognition"
      className={`al-search__icon al-search__icon_ai ${
        searchOptions.searchWithAi ? 'al-search__icon_active' : ''
      } ${disabled ? 'al-search__icon_disabled' : ''}`}
      onClick={() => {
        if (disabled) {
          return;
        }
        dispatch(
          searchActions.optionsChanged({
            options: { ...searchOptions, searchWithAi: !searchOptions.searchWithAi },
            aiToggleClicked: true,
          }),
        );
      }}
    >
      AI
    </span>
  );
};
